"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNpmScope = exports.withPackageLabels = void 0;
const depTypes = require("./dep-types");
function withPackageLabels(pkg, options) {
    if (!options.showNpmScope) {
        return undefined;
    }
    const scope = getNpmScope(pkg.depType);
    return {
        "npm:scope": scope,
    };
}
exports.withPackageLabels = withPackageLabels;
function getNpmScope(depType) {
    switch (depType) {
        case depTypes.DEV:
            return "dev";
        case depTypes.PROD:
            return "prod";
        case depTypes.EXTRANEOUS:
        case depTypes.OPTIONAL:
        default:
            return "unknown";
    }
}
exports.getNpmScope = getNpmScope;
//# sourceMappingURL=dep-labels.js.map